import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

type OnboardingState = {
  /** Whether the user has completed (or skipped) the onboarding tour. */
  seen: boolean;
  /** Whether the modal is currently open. */
  open: boolean;
  /** Mark as seen and close. */
  finish: () => void;
  /** Open the tour again (from settings). */
  start: () => void;
  /** Close without marking seen (e.g. ESC). */
  dismiss: () => void;
};

export const useOnboardingStore = create<OnboardingState>()(
  persist(
    (set) => ({
      seen: false,
      open: false,
      finish: () => set({ seen: true, open: false }),
      start: () => set({ open: true }),
      dismiss: () => set({ open: false }),
    }),
    {
      name: 'uo.onboarding',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ seen: s.seen }),
    },
  ),
);
